import React, { useEffect, useState } from "react";
import "./EmployeeListPage.css";
import {
    fetchEmployees,
    deactivateEmployee,
    reactivateEmployee,
    fetchEmployeeById
} from "../../api/adminEmployeeApi";
import EmployeeFormModal from "./EmployeeFormModal";


const EmployeeListPage = () => {
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editingEmployee, setEditingEmployee] = useState(null);
    const [showCreate, setShowCreate] = useState(false);
    const [statusFilter, setStatusFilter] = useState("ALL");


    const loadEmployees = async () => {
        try {
            const res = await fetchEmployees();
            setEmployees(res.data);
        } catch (e) {
            alert("Failed to load employees");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadEmployees();
    }, []);

    const handleDeactivate = async (id) => {
        if (!window.confirm("Deactivate this employee?")) return;
        await deactivateEmployee(id);
        loadEmployees();
    };

    const handleReactivate = async (id) => {
        if (!window.confirm("Reactivate this employee?")) return;
        await reactivateEmployee(id);
        loadEmployees();
    };

    const handleEdit = async (employee) => {
        try {
            const res = await fetchEmployeeById(employee.id);
            setEditingEmployee(res.data);
        } catch (e) {
            alert("Failed to load employee details");
        }
    };

    const filteredEmployees = employees.filter(e => {
        if (statusFilter === "ALL") return true;
        return e.status === statusFilter;
    });


    if (loading) return <p>Loading employees...</p>;

    return (
        <div className="employees-page">
            <div className="employees-header">
                <div>
                    <h1>Employees</h1>
                    <p className="subtitle">Manage internal users</p>
                </div>
                <button
                    className="create-btn"
                    onClick={() => setShowCreate(true)}
                >
                    + Create Employee
                </button>
            </div>

            <div className="employees-status-filters">
                <button
                    className={`filter-btn ${statusFilter === "ALL" ? "active" : ""}`}
                    onClick={() => setStatusFilter("ALL")}
                >
                    All
                </button>

                <button
                    className={`filter-btn ${statusFilter === "ACTIVE" ? "active" : ""}`}
                    onClick={() => setStatusFilter("ACTIVE")}
                >
                    Active
                </button>

                <button
                    className={`filter-btn ${statusFilter === "INACTIVE" ? "active" : ""}`}
                    onClick={() => setStatusFilter("INACTIVE")}
                >
                    Inactive
                </button>
            </div>


            <div className="table-container">
                <table className="employees-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {employees.length === 0 && (
                            <tr>
                                <td colSpan="5">No employees found</td>
                            </tr>
                        )}

                        {filteredEmployees.map(e => {
                            const isActive = e.status === "ACTIVE";

                            return (
                                <tr key={e.id}>
                                    <td>{e.name}</td>
                                    <td>{e.email}</td>
                                    <td>{e.role}</td>
                                    <td>
                                        <span className={`admin-employee-badge ${isActive ? "admin-employee-active" : "admin-employee-inactive"}`}>
                                            {e.status}
                                        </span>
                                    </td>
                                    <td>
                                        <button
                                            className="link-btn"
                                            onClick={() => handleEdit(e)}
                                        >
                                            Edit
                                        </button>

                                        {isActive ? (
                                            <button
                                                className="link-btn"
                                                onClick={() => handleDeactivate(e.id)}
                                            >
                                                Deactivate
                                            </button>
                                        ) : (
                                            <button
                                                className="link-btn"
                                                onClick={() => handleReactivate(e.id)}
                                            >
                                                Reactivate
                                            </button>
                                        )}
                                    </td>

                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            {/* 👇 PLACE MODAL HERE */}
            {(showCreate || editingEmployee) && (
                <EmployeeFormModal
                    mode={editingEmployee ? "edit" : "create"}
                    employee={editingEmployee}
                    onClose={() => {
                        setShowCreate(false);
                        setEditingEmployee(null);
                    }}
                    onSuccess={loadEmployees}
                />
            )}
        </div>
    );
};

export default EmployeeListPage;
